import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'

export default defineNuxtPlugin(async ({ $pinia }) => {
  if (process.server) {
    const affiliateCustomizationStore = useAffiliateCustomizationStore($pinia)
    const host = useRequestHeaders(['host']).host
    if (host) {
      await affiliateCustomizationStore.getNoAuthActiveAffiliateCustomizationsByHost(host)
    }
  }
})
